import appNotificationService from "./appNotificationService";

import authHeader from "../authHeader";
import {useMenuStore} from "../../stores/menuStore";
import AxiosService from "../axiosService";

class AppMenuService {

  getStoreInstance() {
    if (!this.store) {
      this.store = useMenuStore()
    }
    return this.store
  }

  async list() {
    try {
      if (this.getStoreInstance().isLoaded) {
        return this.getStoreInstance().getRecords;
      } else {
        let response = await AxiosService.get( "/appMenu/list", {
          headers: authHeader()
        });
        this.getStoreInstance().load(response.data.menus)
        return response.data.menus
      }
    } catch (error) {
      appNotificationService.pushError(error.message);
    }

  }

}

export default new AppMenuService();
